import Script from 'next/script';
import { SEO_INDEXABLE } from '@/constants/seo';

/**
 * Google Analytics 4.
 *
 * - Mã GA lấy từ biến NEXT_PUBLIC_GA4_IDS trong .env, nhiều mã cách nhau bằng dấu phẩy
 *   để chạy SONG SONG (vd GA cũ + GA mới):  NEXT_PUBLIC_GA4_IDS=G-YT69X6YZR8,G-LZK24WTJXR
 * - Không khai báo biến => dùng DEFAULT_GA4_IDS bên dưới (chạy song song cũ + mới).
 * - Chỉ chạy trên PROD (APP_URL = anthu.vn). DEV/UAT/local không gửi dữ liệu vào GA thật.
 */
const DEFAULT_GA4_IDS = 'G-YT69X6YZR8,G-LZK24WTJXR'; // GA cũ + GA mới (property anthu.vn, tài khoản CÔNG TY TNHH AN THƯ THE DIAMOND STORE)

export const GA4_IDS = (process.env.NEXT_PUBLIC_GA4_IDS || DEFAULT_GA4_IDS)
  .split(',')
  .map((id) => id.trim())
  .filter((id) => /^G-[A-Z0-9]+$/.test(id));

const GoogleAnalytics = () => {
  if (!SEO_INDEXABLE || GA4_IDS.length === 0) return null;
  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA4_IDS[0]}`} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          ${GA4_IDS.map((id) => `gtag('config', '${id}');`).join('\n          ')}
        `}
      </Script>
    </>
  );
};

export default GoogleAnalytics;
